module.exports = __webpack_public_path__ + "files/64571907414b8b8a3cdef934961d69ea.svg";